module.exports = __webpack_public_path__ + "img/r-cb6-101.61e96a50.gif";